// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__ByqUl","log":"ModalInventoryLogs_log__2Wnzu","date":"ModalInventoryLogs_date__3Pj6j","userName":"ModalInventoryLogs_userName__VRgTH"};